import CheckWebpFeature from "./src/common/ggfx-client/module/webp-checker";
CheckWebpFeature();

export { wrapRootElement } from "./src/common/apollo/wrap-root-element";

// export const shouldUpdateScroll = ({
//     routerProps: { location },
//     getSavedScrollPosition
// }, themeOptions) => {
  
//     // Avoid to scroll to top when next page trigger click
//     // But this feature should condiser with details page back scroll too

//     console.log("getSavedScrollPosition", getSavedScrollPosition, themeOptions);
//     // const { pathname } = location
//     // const scrollToTopRoutes = [`/property/for-sale/`, `/property/to-rent/`, `/${themeOptions.news_insight}/`]

//     if (scrollToTopRoutes.indexOf(pathname) !== -1) {
//       window.scrollTo(0, 0)
//     }

//     if (location.pathname.match(/property\/for-sale/)) {
//       return false;
//     }
//     if (location.pathname.match(/property\/to-rent/)) {
//       return false;
//     }

//     if (location.pathname.match(/commercial-property\/for-sale/)) {
//       return false;
//     }
//     if (location.pathname.match(/commercial-property\/to-rent/)) {
//       return false;
//     }
  
//     return true;
// };

// export function shouldUpdateScroll(prevRouterProps, { location }) {
//     //console("location =>", prevRouterProps, location)
//     window.scrollTo(0, 0)
//     const body = document.getElementsByTagName('body')[0]
//     body.scrollTop = 0
//     return false
// }

export const onRouteUpdate = ({ location, prevLocation }) => { 
  // if (location.pathname.split('?').length > 0) {
  //   window.history.replaceState(null, '', location.pathname);
  // } 

  const params = new URLSearchParams(location.search);
  var parameter1 = params.get("transType");

  //console.log("pathname", location)

  const defaultArea = process.env.GATSBY_DEFAULT_AREA ? process.env.GATSBY_DEFAULT_AREA : "London";
  const defaultArea_Slug = defaultArea.toLowerCase().replace(/ /g,'-');

  if(location.pathname === "/property-for-sale/"){
    window.location.replace("/property/for-sale/in-"+defaultArea_Slug);
  }

  if(location.pathname === "/property-to-rent/"){
    window.location.replace("/property/to-rent/in-"+defaultArea_Slug);
  }

  if(location.pathname.indexOf("property-for-sale") > 0 && location.search.indexOf("transType=1") > 0){
    window.location.replace("/property/for-sale/in-"+defaultArea_Slug);
  }

  //console.log("old pathname", prevLocation?.search?.indexOf("utm_source"))

}

// const addScript = url => {
//   const script = document.createElement("script")
//   script.src = url
//   script.async = true
//   document.body.appendChild(script)
// }

// export const onClientEntry = () => {
//   window.onload = () => { 
//     sessionStorage.setItem("pageView", "");
//     //console.log("onload page");
//     if(process.env.GATSBY_LEADOO_CHAT_ID){
//       addScript("https://bot.leadoo.com/bot/dynamic.js?company="+process.env.GATSBY_LEADOO_CHAT_ID+"&mode=spa")
//     }
//   }
// }